import { useMutation } from '@apollo/client'
import { notifyError } from 'Utils/errorNotifications'
import blackoutDateMutation from 'Shared/CalendarBlock/Queries/datesBlockCreateMutation'
import updateDateMutation from 'Shared/CalendarBlock/Queries/datesBlockUpdateMutation'

const formatDate = dateString => {
  if (!dateString || window.roverData?.campgroundCountryUs === 'true') return dateString

  const parts = dateString.split('-')
  if (parts.length !== 3) return dateString

  return `${parts[0]}-${parts[2].padStart(2, '0')}-${parts[1].padStart(2, '0')}`
}

// Custom hook to encapsulate blackout date mutation logic
const useBlackoutMutations = ({ blackoutId, data, deleteBlock, from, selected, setSuccess, to }) => {
  const [createBlackoutDate, { loading, error, reset: resetCreate }] = useMutation(blackoutDateMutation)
  const [BlackoutDateMutation, { loading: updating, error: updateError, reset: resetUpdate }] =
    useMutation(updateDateMutation)

  const handleBlockSite = async () => {
    if (!data?.site_id || !from || !to)
      return notifyError('Please fill in all required fields')
    if (!selected?.label)
      return notifyError('Please select a reason')
    try {
      const formattedFrom = formatDate(from)
      const formattedTo = formatDate(to)
      const input = { from: formattedFrom, to: formattedTo, siteId: data.site_id, reason: selected.label }
      const response = await createBlackoutDate({ variables: { input } })

      if (response?.data?.createBlackoutDate?.blackoutDate) {
        setSuccess(true)
        window.location.reload()
      } else
        notifyError('Failed to create blackout date: No data returned')
    } catch (error) {
      notifyError(`Failed to create BlackoutDate: ${error?.message || error}`)
    }
  }

  const handleUpdateSite = async () => {
    if (!blackoutId) return notifyError('Missing blackout id')
    if (!selected?.label) return notifyError('Please select a reason')

    try {
      const response = await BlackoutDateMutation({
        variables: { input: { id: blackoutId, reason: selected.label } },
      })

      if (response?.data?.updateBlackoutDate) {
        setSuccess(true)
        window.location.reload()
      } else
        notifyError('Failed to update blackout date: No data returned')
    } catch (updateError) {
      notifyError(`Failed to update BlackoutDate: ${updateError.message || updateError}`)
    }
  }

  const handleDeleteBlock = async () => {
    if (!blackoutId) return notifyError('No Block ID provided for deletion.')
    try {
      const response = await BlackoutDateMutation({
        variables: { input: { id: blackoutId, delete: deleteBlock } },
      })

      if (response?.data?.updateBlackoutDate) {
        setSuccess(true)
        setTimeout(() => window.location.reload(), 1500)
      } else
        notifyError('Failed to delete blackout date: No data returned')
    } catch (updateError) {
      notifyError(`Failed to update BlackoutDate: ${updateError.message || updateError}`)
    }
  }

  const resetErrors = () => {
    resetCreate()
    resetUpdate()
  }

  return {
    handleBlockSite,
    handleDeleteBlock,
    handleUpdateSite,
    loading,
    error,
    updating,
    updateError,
    resetErrors,
  }
}

export default useBlackoutMutations
